import React, {Fragment} from 'react';
import {Slider} from 'components';
import {noop} from 'helpers';
import css from './mood-meter.module.scss';

export function MoodTable({ emotions }) {
  return (
    <div className={css('grid', 'small')}>
      { emotions.map(line =>
        <Fragment key={line.key}>
          <span>{ line.bad }</span>
          <Slider value={line.value} setValue={noop} max={10} filled="colored" disabled />
          <span dangerouslySetInnerHTML={{ __html: line.good.replace(' ', '<br />') }} />
        </Fragment>
      ) }
    </div>
  );
}
